export const zIndex = {
  ContextualMenu: 10,
  HelpPrompt: 20,
  Dropdown: 30,
  UserMenu: 50,
  Header: 40,
  Modal: 100,
  GlobalLoader: 999,
};
